import * as tslib_1 from "tslib";
import updateCategory from '../orchestrators/updateCategory';
/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
export default orchestratorAction('selectCategory', function selectCategory(category) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var currentSubCategoryKey;
        return tslib_1.__generator(this, function (_a) {
            currentSubCategoryKey = category.subcategories && category.subcategories[0] && category.subcategories[0].key;
            updateCategory(category.key, currentSubCategoryKey, null);
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=selectCategory.js.map